import React from 'react';
import { inject, observer } from 'mobx-react';
import H5ThreadList from './h5';
import PCThreadList from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { ThreadAction } from '@stores/thread/action';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Toast from '@components/Toast';
import { TopicAction } from '@stores/topic/action';
interface ThreadListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    topic?: TopicAction
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    currentPage?: number;
    pageSize?: number;
    thread?: ThreadAction
    data?: any
    namespace?: string; // 允许外部指定 listStore 命名空间，默认 threadList
    listStore?: any; // 允许外部传入自定义 listStore（例如 topic.listStore）
    searchKeyword?: any // 需要高亮的关键字
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
    emptyExtra?: React.ReactNode; // 空态文案下方的自定义插槽
    isSelf?: boolean    // 是否是作者自己
    showThreadStatus?: any  // 是否显示帖子状态（为个人中心发帖列表加的）

}
type ThreadListAllProps = ThreadListProps & RouteComponentProps;
interface ThreadListState {
    
}
@inject('app', 'site', 'user', 'thread', 'topic')
@observer
class ThreadList extends React.Component<ThreadListAllProps, ThreadListState> {
    constructor(props) {
        super(props);

        // 从 props 中获取初始值设置到 state
        this.state = {
            
        };
    }
    componentDidMount() {
        // 可以在这里添加初始化逻辑

    }

    /** 更新反馈列表项中的 thread 字段 */
    patchFeedbackThread = (store, namespace, item, threadUpdates) => {
        return store.updateListItem({
            namespace,
            id: item.id || item._id,
            updates: {
                thread: {
                    ...item.thread,
                    ...threadUpdates,
                },
            },
        });
    };

    // 处理触底加载下一页
    handleLoadMore = () => {
        const { thread, namespace = 'feedbackList' } = this.props;
        if (!thread) return;

        const list = thread.listStore.lists[namespace];
        if (!list) return;

        const currentPage = list.attribs?.page || 1;
        const pageSize = list.attribs?.pageSize || 20;

        const params: any = {
            'page[number]': currentPage + 1,
            'page[size]': pageSize,
        };

        if (list.search?.filter) {
            params.filter = list.search.filter;
        }

        if (namespace === 'threadList') {
            thread.getThreadList(params);
        }
    };

    // 点赞
    likeClick = async (item) => {
        const { thread, namespace = 'feedbackList', listStore } = this.props;
        const store = listStore || thread?.listStore;
        if (!store || !thread) return;

        const prevIsLiked = item.thread?.isLiked;
        const prevLikeCount = item.thread?.likeCount;
        const newIsLiked = !prevIsLiked;
        const newLikeCount = newIsLiked
            ? (prevLikeCount || 0) + 1
            : Math.max((prevLikeCount || 0) - 1, 0);

        const updated = this.patchFeedbackThread(store, namespace, item, {
            isLiked: newIsLiked,
            likeCount: newLikeCount,
        });
        console.log('[likeClick] 本地更新:', { id: item.id, threadId: item.thread?.id, newIsLiked, newLikeCount, updated });

        const params = {
            id: item.thread?.id,
            type: 'thread',
            isLiked: newIsLiked,
            likeCount: prevLikeCount,
        };

        try {
            const res = await thread.createUserslikes(params, namespace);
            console.log('[likeClick] 接口返回:', res);
        } catch (error) {
            console.error('[likeClick] 接口错误:', error);
            this.patchFeedbackThread(store, namespace, item, {
                isLiked: prevIsLiked,
                likeCount: prevLikeCount,
            });
        }
    }

    // 收藏/取消收藏
    favoriteClick = async (item) => {
        const { thread, namespace = 'feedbackList', listStore } = this.props;
        const store = listStore || thread?.listStore;
        if (!store || !thread) return;

        const prevIsFavorite = item.thread?.isFavorite;
        const prevFavoriteCount = item.thread?.favoriteCount;
        const newIsFavorite = !prevIsFavorite;
        const newFavoriteCount = newIsFavorite
            ? (prevFavoriteCount || 0) + 1
            : Math.max((prevFavoriteCount || 0) - 1, 0);

        const updated = this.patchFeedbackThread(store, namespace, item, {
            isFavorite: newIsFavorite,
            favoriteCount: newFavoriteCount,
        });
        console.log('[favoriteClick] 本地更新:', { id: item.id, threadId: item.thread?.id, newIsFavorite, newFavoriteCount, updated });

        const params = {
            id: item.thread?.id,
            type: 'thread',
            isFavorite: newIsFavorite,
        };

        try {
            const res = await thread.threadFavorite(params);
            console.log('[favoriteClick] 接口返回:', res);
        } catch (error) {
            console.error('[favoriteClick] 接口错误:', error);
            this.patchFeedbackThread(store, namespace, item, {
                isFavorite: prevIsFavorite,
                favoriteCount: prevFavoriteCount,
            });
        }
    }

    // 去帖子详情页
    goDetails = (item) => {
        const { thread, listStore } = this.props;
        const store = listStore || thread?.listStore;
        if (store?.setList) {
            // 清空 postList，避免进入新帖详情后沿用上一个帖子的评论
            store.setList({
                namespace: 'postList',
                data: { data: [] },
                page: 1,
                path: 'data',
                hasMore: true
            });
            store.setAttribute?.({
                namespace: 'postList',
                key: 'requestError',
                value: { isError: false, errorText: '' }
            });
        }
        // 进入详情页前清空 threadData，避免展示旧的详情数据
        if (thread && typeof thread.setThreadData === 'function') {
            thread.setThreadData(null);
        }
        if (this.props.history && item.id) {
            // this.props.history.push(`/threadDetail/${item.id}`);
            window.open(`/threadDetail/${item.thread?.id}`);
        }
    }

    // 去话题详情页
    goTopicDetails = (item) => {
        let { topic } = this.props;
        if (this.props.history && item.id) {
            console.log('设置焦点id', item.id, topic);
            topic.setFollowTopicFocusId(item.id);
            this.props.history.push(`/topicDetail/${item.id}`);
        }
    }
    // 去个人中心
    goUser = (user) => {
        console.log('跳转用户中心');
        if (this.props.history && user.code) {
            this.props.history.push(`/user/${user.code}`);
        }
    }

    render() {
        const { site, app, data, thread, onLoadMore, loading: propsLoading, hasMore: propsHasMore, namespace = 'feedbackList', showThreadStatus, listStore, searchKeyword, emptyText, emptyIcon, emptyBoxStyle, emptyExtra, isSelf, ...props } = this.props;
        const platform = app?.platform || 'h5';
        let {  } = this.state;
        // 确保传递 data 属性，即使为空数组
        const postListData = data || [];

        // 优先使用父组件传递的 loading 和 hasMore，如果没有则从 thread store 获取
        const store = listStore || thread?.listStore;
        const loading = propsLoading !== undefined ? propsLoading : (store?.lists[namespace]?.loading || false);
        const hasMore = propsHasMore !== undefined ? propsHasMore : (store?.lists[namespace]?.hasMore ?? true);

        // 优先使用父组件传递的 onLoadMore，如果没有则使用默认的 handleLoadMore
        const loadMoreHandler = onLoadMore || this.handleLoadMore;

        // 根据 namespace 决定显示点赞还是收藏操作
        const isFavoriteList = namespace === 'usersFavoritesList';
        const actionType = isFavoriteList ? 'favorite' : 'like';
        const actionClick = isFavoriteList ? this.favoriteClick : this.likeClick;

        if (platform === 'pc') {
            return <PCThreadList
                likeClick={this.likeClick}
                actionType={actionType}
                actionClick={actionClick}
                goDetails={this.goDetails}
                goUser={this.goUser} {...props}
                data={postListData}
                loading={loading}
                hasMore={hasMore}
                searchKeyword={searchKeyword}
                onLoadMore={loadMoreHandler}
                emptyText={emptyText}
                emptyIcon={emptyIcon}
                emptyBoxStyle={emptyBoxStyle}
                emptyExtra={emptyExtra}
                namespace={namespace}
                showThreadStatus={showThreadStatus}
                isSelf={isSelf}
            />;
        } else {
            return <H5ThreadList
            likeClick={this.likeClick}
            actionType={actionType}
            actionClick={actionClick}
            goDetails={this.goDetails}
            {...props} goUser={this.goUser}
            data={postListData}
            loading={loading}
            hasMore={hasMore}
            searchKeyword={searchKeyword}
            onLoadMore={loadMoreHandler}
            emptyText={emptyText}
            emptyIcon={emptyIcon}
            emptyBoxStyle={emptyBoxStyle}
            emptyExtra={emptyExtra}
            namespace={namespace}
            showThreadStatus={showThreadStatus}
            isSelf={isSelf}
        />;
        }
    }
}

export default withRouter(ThreadList);
